<template>
  <v-dialog v-model="value" width="800" persistent scrollable id="dialog">
    <v-card>
      <div class="text-xs-right">
        <v-btn 
          flat 
          fab 
          small
          :loading="loading" 
          @click="() => {
            this.clearEventListener()
            $emit('input', false)
          }" 
        >
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <template v-if="selectedBot.theme == 'universalutilities'">
          <div class="caption">{{ $t('ประปา') }}</div>
          <div v-if="selectedBot.uu_areaname" class="primary--text">
            {{ selectedBot.uu_areaname }}
          </div>
          <template v-else>
            <v-select
              :items="areaname"
              v-model="input.uuAreaName"
              label="ประปา"
              placeholder="ประปา"
              solo
            ></v-select>
          </template>
          <v-layout wrap>
            <v-flex sm6 style="padding-right: 1em">
              <div class="form-control">
                <label>ชื่อ</label>
                <input v-model="input.uu_name" type="text" />
              </div>
            </v-flex>
            <v-flex sm6 style="padding-right: 1em">
              <div class="form-control">
                <label>เบอร์โทร</label>
                <input v-model="input.phoneno" type="number" />
              </div>
            </v-flex>
            <v-flex sm6 style="padding-right: 1em">
              <div class="form-control">
                <label>LineID</label>
                <input v-model="input.search" type="text" />
              </div>
            </v-flex>
            <v-flex sm6>
              <label>{{ $t('Register Status') }}</label>
              <multiselect
                v-model="input.uu_register_status"
                :options="[
                  'ยังไม่กรอกข้อมูล',
                  'กรอกข้อมูลไม่สำเร็จ',
                  'ยังไม่กดส่งพิกัด',
                  'ลงทะเบียนสำเร็จ',
                  'กรอกข้อมูลไม่ครบ'
                ]"
                selectLabel
                selectedLabel
                deselect-label
                :placeholder="$t('Register Status')"
              ></multiselect>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div class="form-control">
                <label>Last Conversation From</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openStartDate"
                      v-model="openStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="input.lastconversationfromdate"
                          v-on="on"
                          clearable
                        />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="input.lastconversationfromdate"
                        @input="openStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openStartTime"
                      v-model="openStartTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationfromtime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      :disabled="input.lastconversationfromdate == null"
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-model="input.lastconversationfromtime"
                          v-on="on"
                          :disabled="input.lastconversationfromdate == null"
                        />
                      </template>
                      <v-time-picker
                        v-if="openStartTime"
                        v-model="input.lastconversationfromtime"
                        full-width
                        @click:minute="$refs.openStartTime.save(input.lastconversationfromtime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationfromdate = null
                        input.lastconversationfromtime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex>
              <div class="form-control">
                <label>Last Conversation To</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openEndDate"
                      v-model="openEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="input.lastconversationtodate"
                          v-on="on"
                          clearable
                        />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="input.lastconversationtodate"
                        @input="openEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openEndTime"
                      v-model="openEndTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationtotime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="input.lastconversationtodate == null"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-model="input.lastconversationtotime"
                          v-on="on"
                          :disabled="input.lastconversationtodate == null"
                        />
                      </template>
                      <v-time-picker
                        v-if="openEndTime"
                        v-model="input.lastconversationtotime"
                        full-width
                        @click:minute="$refs.openEndTime.save(input.lastconversationtotime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationtodate = null
                        input.lastconversationtotime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </template>
        <template v-if="selectedBot.theme != 'universalutilities'">
          <div class="caption">{{ $t('Search') }} {{ $t('name_email_phone') }}</div>
          <div class="form-control">
            <input type="text" v-model="input.search" :placeholder="`${$t('Search')}`" />
          </div>

          <div class="caption">{{ $t('Status') }}</div>
          <multiselect
            class="shot"
            :options="statusOptions"
            v-model="input.status"
            :placeholder="$t('Status')"
            :multiple="true"
            :taggable="true"
            @input="errorMaxlength = false"
            @tag="addTagStatus"
            id="selectStatus"
            >
          </multiselect>
          <small style="color:red" v-if="errorMaxlength">
            {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
          >

          <div class="caption mt-2">{{ $t('Tags') }}</div>
          <multiselect
            class="shot"
            :options="tagOptions"
            v-model="input.tags"
            :placeholder="$t('Tags')"
            :multiple="true"
            :taggable="true"
            @tag="addTagTag"
          >
          </multiselect>
        </template>
        <template v-if="$aston.astonpages.includes($store.state.livechat.pageid)">
          <v-select
            v-model="input.assignadminname"
            :items="computedAstonAdmins"
            outline
            label="Assign to"
            hide-details
            class="mt-4"
            color="primary"
          ></v-select>

          <div class="mt-4">ประเภทลูกค้า</div>
          <v-select
            v-model="input.session"
            :items="$store.state.astonCustomerGroup"
            outline
            label="ประเภทลูกค้า"
            hide-details
            class="mt-1"
            color="primary"
          ></v-select>

          <v-layout class="mt-3">
            <v-flex>
              <div class="form-control">
                <label>Last Conversation From</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openStartDate"
                      v-model="openStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="input.lastconversationfromdate"
                          v-on="on"
                          clearable
                        />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="input.lastconversationfromdate"
                        @input="openStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openStartTime"
                      v-model="openStartTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationfromtime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      :disabled="input.lastconversationfromdate == null"
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-model="input.lastconversationfromtime"
                          v-on="on"
                          :disabled="input.lastconversationfromdate == null"
                        />
                      </template>
                      <v-time-picker
                        v-if="openStartTime"
                        v-model="input.lastconversationfromtime"
                        full-width
                        @click:minute="$refs.openStartTime.save(input.lastconversationfromtime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationfromdate = null
                        input.lastconversationfromtime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex>
              <div class="form-control">
                <label>Last Conversation To</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openEndDate"
                      v-model="openEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          v-model="input.lastconversationtodate"
                          v-on="on"
                          clearable
                        />
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="input.lastconversationtodate"
                        @input="openEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openEndTime"
                      v-model="openEndTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationtotime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="input.lastconversationtodate == null"
                    >
                      <template v-slot:activator="{ on }">
                        <input
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          v-model="input.lastconversationtotime"
                          v-on="on"
                          :disabled="input.lastconversationtodate == null"
                        />
                      </template>
                      <v-time-picker
                        v-if="openEndTime"
                        v-model="input.lastconversationtotime"
                        full-width
                        @click:minute="$refs.openEndTime.save(input.lastconversationtotime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationtodate = null
                        input.lastconversationtotime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </template>
        <br />
        <div class="caption mt-2">{{ $t('Channel') }}</div>
        <h4 style="text-transform: capitalize;">{{ $store.state.livechat.app }}</h4>
        <div class="caption mt-2">{{ $t('Read Status') }}</div>
        <v-radio-group v-model="input.filter_admin_read" row class="mt-0">
          <v-radio :label="$t('All')" :value="null" color="primary"></v-radio>
          <v-radio :label="$t('Read')" :value="true" color="primary"></v-radio>
          <v-radio :label="$t('Unread')" :value="false" color="primary"></v-radio>
        </v-radio-group>
        <div class="mb-3 form-control">
          <div class="form-control mt-2" v-if="$store.state.livechat.pageid === '100733472248907'">
            <div class="caption">เวลา</div>
            <v-layout wrap>
              <v-flex xs5 class="form-control" :class="{ 'has-error': errors.has('startdate') }">
                <v-menu
                  ref="openStartDate"
                  v-model="openStartDate"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <input
                      type="text"
                      class="form-control browser-default"
                      :placeholder="$t('Date')"
                      readonly
                      v-model="startDate"
                      v-on="on"
                      clearable
                      small
                    />
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="startDate"
                    @input="openStartDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs3 class="px-1">
                <multiselect
                  class="time"
                  v-model="startTimeHours"
                  :options="optionsHours"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  :placeholder="$t('ชั่วโมง')"
                  :disabled="startDate == null"
                ></multiselect>
              </v-flex>
              <v-flex xs3 class="px-1">
                <multiselect
                  class="time"
                  v-model="startTimeMinute"
                  :options="optionsMinute"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  :placeholder="$t('นาที')"
                  :disabled="startDate == null"
                ></multiselect>
              </v-flex>
              <v-flex xs1>
                <v-btn
                  fab
                  flat
                  small
                  color="primary"
                  style="height: 35px; width: 35px"
                  @click="
                    selectedDate.start = null
                    startDate = null
                    startTimeHours = '00'
                    startTimeMinute = '00'
                  "
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="form-control">
              <v-layout wrap>
                <v-flex class="form-control" xs5 :class="{ 'has-error': errors.has('enddate') }">
                  <v-menu
                    ref="openEndDate"
                    v-model="openEndDate"
                    :close-on-content-click="false"
                    full-width
                    max-width="290px"
                    color="primary"
                  >
                    <template v-slot:activator="{ on }">
                      <input
                        type="text"
                        class="form-control browser-default"
                        :placeholder="$t('Date')"
                        readonly
                        v-model="endDate"
                        v-on="on"
                        clearable
                      />
                    </template>
                    <v-date-picker
                      color="primary"
                      v-model="endDate"
                      @input="openEndDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs3 class="px-1">
                  <!-- <v-flex xs3 class="pl-1"> -->
                  <multiselect
                    class="time"
                    v-model="endTimeHours"
                    :options="optionsHours"
                    :searchable="false"
                    :close-on-select="true"
                    :show-labels="false"
                    :placeholder="$t('ชั่วโมง')"
                    :disabled="endDate == null"
                  ></multiselect>
                </v-flex>
                <v-flex xs3 class="px-1">
                  <multiselect
                    class="time"
                    v-model="endTimeMinute"
                    :options="optionsMinute"
                    :searchable="false"
                    :close-on-select="true"
                    :show-labels="false"
                    :placeholder="$t('นาที')"
                    :disabled="endDate == null"
                  ></multiselect>
                </v-flex>
                <!-- </v-flex> -->
                <v-flex xs1>
                  <v-btn
                    fab
                    flat
                    small
                    color="primary"
                    style="height: 35px; width: 35px"
                    @click="
                      selectedDate.end = null
                      endDate = null
                      endTimeHours = '00'
                      endTimeMinute = '00'
                    "
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-layout>
          <v-flex class="pa-1">
            <v-btn block depressed @click="clearSearch" :loading="loading">
              <v-icon>clear</v-icon>
              {{ $t('Clear All') }}
            </v-btn>
          </v-flex>
          <v-flex class="pa-1">
            <v-btn @click="onSearch()" type="submit" block depressed color="primary" :loading="loading">
              <v-icon>search</v-icon>
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import DateFilter from '../dashboard/DateFilter'

const systemTags = {
  'ตรวจสลิป 1 ครั้ง': '{{slip_completed_1}}',
  'ตรวจสลิปมากกว่า 1 ครั้ง': '{{slip_completed_more_than_1}}',
}

export default {
  props: {
    value: {
      default: false
    },
    isUnlock: { default: true }
  },
  components: {
    Multiselect,
    DateFilter
  },
  data() {
    return {
      optionsHours: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24'
      ],
      optionsMinute: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48',
        '49',
        '50',
        '51',
        '52',
        '53',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59',
        '60'
      ],
      startDate: null,
      startTimeHours: '00',
      startTimeMinute: '00',
      endTimeHours: '00',
      endTimeMinute: '00',
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      openEndDate: false,
      openEndTime: false,
      selectedDate: {
        start: null,
        end: null
      },
      errorMaxlength: false,
      tagOptions: [],
      statusOptions: [],
      input: {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        filter_admin_read: null,
        session: '',
        assignadminname: ''
      },
      openStartDate: false,
      openEndDate: false,
      openStartTime: false,
      openEndTime: false,
      loading: false,
      connect_fb: false,
      connect_line: false,
      connect_ig: false,
      connect_google: false,
      connect_whatsapp: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      astonAdmins: 'getAstonAdmins',
      loadingAstonAdmin: 'getLoadingAstonAdmins',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      userTags: 'getUserTags',
      loadingUserTags: 'getLoadingUserTags'
    }),
    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    },
    computedAstonAdmins() {
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        if (this.astonAdmins) {
          var admins = this.astonAdmins.map(el => {
            return {
              text: el.name,
              value: el.name
            }
          })
          admins.unshift({ text: 'ยังไม่ได้ Assign', value: '' })
          return admins
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  mounted() {
    const vm = this
    if (vm.isUnlock) {
      vm.getUserTagList()
      vm.getUserStatusList()
    }
    const packages = this.selectedBot.packages
    if (packages.includes('facebook')) {
      vm.connect_fb = true
    }
    if (packages.includes('line')) {
      vm.connect_line = true
    }
    if (packages.includes('instagram')) {
      vm.connect_ig = true
    }
    if (packages.includes('whatsapp')) {
      vm.connect_whatsapp = true
    }
    if (packages.includes('google')) {
      vm.connect_google = true
    }
     
    this.$nextTick(() => {
      document.addEventListener('keyup', this.handleKeydown)
    })
  },
  methods: {
    addTagStatus(newTag) {
      if (newTag.length <= 25) {
        this.errorMaxlength = false
        this.statusOptions.push(newTag)
        this.input.status = newTag
      } else {
        this.errorMaxlength = true
      }
    },
    addTagTag(newTag) {
      this.tagOptions.push(newTag)
      this.input.tags = newTag
    },
    async getUserTagList() {
      const vm = this
      await vm.$store.dispatch('loadTags')
      if (vm.userTags.length > 0) {
        vm.tagOptions = vm.userTags.map(item => {
          return item.name
        })
      }
      vm.tagOptions.unshift(...Object.keys(systemTags))
    },
    async getUserStatusList() {
      const vm = this
      await vm.$store.dispatch('loadStatus')
      if (vm.userStatus.length > 0) {
        vm.statusOptions = vm.userStatus.map(item => {
          return item.name
        })
      }
    },
    clearSearch() {
      this.selectedDate = {
        end: null,
        start: null
      }
      this.input = {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        filter_admin_read: null,
      }

      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        this.input.session = ''
        this.input.assignadminname = ''
      }
      this.onSearch()
    },
    async onSearch() {
      const vm = this
      if (vm.loading) return
      if (this.input.lastconversationfromdate) {
        this.input['lastconversationfrom'] =
          this.input.lastconversationfromdate +
          (this.input.lastconversationfromtime
            ? ' ' + this.input.lastconversationfromtime
            : ' 00:00')
      } else {
        this.input['lastconversationfrom'] = null
      }
      if (vm.startDate !== null && vm.startTimeHours !== null && vm.startTimeMinute !== null) {
        vm.selectedDate.start = `${vm.startDate} ${vm.startTimeHours}:${vm.startTimeMinute}:00`
      } else {
        if (vm.startDate !== null) {
          vm.selectedDate.start = `${vm.startDate} 00:00:00`
        } else {
          vm.selectedDate.start = null
        }
      }

      if (vm.endDate !== null && vm.endTimeHours !== null && vm.endTimeMinute !== null) {
        vm.selectedDate.end = `${vm.endDate} ${vm.endTimeHours}:${vm.endTimeMinute}:00`
      } else {
        if (vm.endDate !== null) {
          vm.selectedDate.end = `${vm.endDate} 00:00:00`
        } else {
          vm.selectedDate.end = null
        }
      }

      if (vm.selectedDate.start && vm.selectedDate.end) {
        vm.input.datefrom = vm.selectedDate.start
        vm.input.dateto = vm.selectedDate.end
      } else {
        vm.input.datefrom = null
        vm.input.dateto = null
      }

      if (this.input.lastconversationtodate) {
        this.input['lastconversationto'] =
          this.input.lastconversationtodate +
          (this.input.lastconversationtotime ? ' ' + this.input.lastconversationtotime : ' 23:59')
      } else {
        this.input['lastconversationto'] = null
      }

      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        this.input.adminname = this.input.assignadminname
      }

      let tags = [...this.input.tags]
      tags = tags.map(tag => systemTags[tag] || tag)

      this.$store.commit('SET_LIVECHAT_FILTER', { ...this.input, tags })
      this.$emit('onSearch', true)
      this.loading = true
      try {
        await this.$store.dispatch('forceLoadLastestUsers')
        this.$emit('onSearch', false)
      } catch (error) {}
      this.loading = false

      this.clearEventListener()
      this.$emit('input', false)
    },
    handleKeydown(event) {
      const keyValue = event.key;
      if (keyValue === 'Enter') {
        this.onSearch()
      }
    },
    clearEventListener() {
      document.removeEventListener('keyup', this.handleKeydown)
    }
  },
  watch: {
    value: function(val) {
      if (val) {
        document.addEventListener('keyup', this.handleKeydown)
      }
    } 
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatSearch.vue